"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAmountForDiscountOnItem = getAmountForDiscountOnItem;
exports.getItemsQuantityById = getItemsQuantityById;
exports.getQuantityOfItems = getQuantityOfItems;
exports.isItemInDiscount = void 0;
exports.round = round;
// @ts-check
/** @param { number } number */
function round(number) {
  return Math.round(number * 100) / 100;
}

/** @param { import("../entities/types").Order } order */
function getItemsQuantityById(order) {
  var isBrand = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var excludedFabrics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var quantitiesById = {};
  var _order$clothes = order.clothes,
    clothes = _order$clothes === void 0 ? [] : _order$clothes;
  var filteredClothes = clothes.filter(function (cloth) {
    return !excludedFabrics.includes(cloth.fabric);
  });
  filteredClothes.forEach(function (cloth) {
    var _cloth$items = cloth.items,
      items = _cloth$items === void 0 ? [] : _cloth$items;
    items.forEach(function (item) {
      var _item$quantity;
      if (isBrand && !cloth.brand) return;
      // @ts-ignore
      if (!quantitiesById[item.id]) {
        // @ts-ignore
        quantitiesById[item.id] = 0;
      }
      var itemQuantity = (_item$quantity = item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 1;
      // @ts-ignore
      quantitiesById[item.id] += itemQuantity;
    });
  });
  return quantitiesById;
}

/**
 * @param { string[] } itemIds
 * @returns { number }
 */
// @ts-ignore
function getQuantityOfItems(itemIds, itemsQuantities) {
  return itemIds.reduce(function (sum2, itemId) {
    if (!itemsQuantities[itemId]) return sum2;
    return sum2 + itemsQuantities[itemId];
  }, 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } discount
 * @param { boolean } isBrand
 * @returns { number }
 */
function getAmountForDiscountOnItem(order, discount) {
  var isBrand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var discounts = discount.discountOnItems;
  if (!discounts) return 0;
  var itemsQuantities = getItemsQuantityById(order, isBrand, discount.excludedFabrics);
  return discounts.reduce(function (sum, discountOnItem) {
    var itemIds = discountOnItem.itemIds;
    var quantity = getQuantityOfItems(itemIds, itemsQuantities);
    return sum + quantity * discountOnItem.value;
  }, 0);
}

/**
 * @param { import("../entities/types").Discount } discount
 * @param { string } itemId
 * @returns { boolean }
 */
var isItemInDiscount = exports.isItemInDiscount = function isItemInDiscount(discount, itemId) {
  if (!discount.discountOnItems) return false;
  return discount.discountOnItems.some(function (discountOnItem) {
    return discountOnItem.itemIds.includes(itemId);
  });
};